import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { baseurl, imageUrl } from "../Baseurl";

const HomeSlider = ({ fullbanner }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000); // Simulated loading delay
    return () => clearTimeout(timer);
  }, []);

  const ArrowButton = ({ className, onClick, icon }) => (
    <button className={className} onClick={onClick}>
      {icon}
    </button>
  );

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    lazyLoad: "ondemand",
    prevArrow: <ArrowButton className="slick-prev" icon="❮" />,
    nextArrow: <ArrowButton className="slick-next" icon="❯" />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: false,
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          dots: false,
          autoplaySpeed: 2500,
        }
      }
    ]
  };

  const bannerItems = Array.isArray(fullbanner) ? fullbanner : [];

  return (
    <div className="home-container">
      <Slider {...settings}>
        {bannerItems.map((banner) => (
          <div className="slider-item" key={banner.id}>
            <div className="slider-image-wrapper">
              {loading ? (
                <div
                  className="skeleton-loader"
                  style={{
                    width: "100%",
                    height: "300px",
                    borderRadius: "6px",
                    background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                    backgroundSize: "200% 100%",
                    animation: "shimmer 1.5s infinite"
                  }}
                ></div>
              ) : (
                <img
                  className="slider-image"
                  src={`${imageUrl}banners/${banner.banner_image}`}
                  alt={banner.heading}
                  onLoad={() => setLoading(false)}
                />
              )}
            </div>
            <div className="slider-content">
              <h2 className="mybanhed">{banner.heading}</h2>
              <button className="shop-now-btn">
                <a href={banner.action_url} target="_blank" className="text-white" rel="noopener noreferrer">
                  Shop Now
                </a>
              </button>
            </div>
          </div>
        ))}
      </Slider>

      {/* Inline keyframes for shimmer */}
      <style>{`
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
      `}</style>
    </div>
  );
};

export default HomeSlider;
